import type { ShippedReleaseResponse, ShippedResponse } from '@pulse/contracts';
import { useQuery } from '@tanstack/react-query';

import { apiRequest } from '@/lib/api-client';

/** Shipped for a week or a month, by any date in it; the current one when none is given (SHP-P1 to SHP-P6). */
export function useShipped(view: 'week' | 'month', period: string | null) {
  return useQuery({
    queryKey: ['pages', 'shipped', view, period ?? ''],
    queryFn: () => apiRequest<ShippedResponse>('/api/pages/shipped', { searchParams: { view: view === 'week' ? undefined : view, period: period ?? undefined } }),
    staleTime: 60_000,
  });
}

/** SHP-P8: one PR merged into production, and what it brought there. */
export function useShippedRelease(repositoryName: string, number: string, date: string | null) {
  return useQuery({
    queryKey: ['pages', 'shipped', 'release', repositoryName, number, date ?? ''],
    queryFn: () => apiRequest<ShippedReleaseResponse>(`/api/pages/shipped/releases/${encodeURIComponent(repositoryName)}/${encodeURIComponent(number)}`, { searchParams: { date: date ?? undefined } }),
    staleTime: 60_000,
  });
}
